import { Switch, SwitchProps } from '@components/switch';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormSwitchProps<T = unknown> = FormFieldProps<SwitchProps, T, boolean>;

export function FormSwitch<T>(props: FormSwitchProps<T>) {
  const formFieldProps = useFormField(props);

  return <Switch {...props} {...formFieldProps} />;
}
